export const CREATE_PROMO_CODE = 'CREATE_PROMO_CODE';
export const CREATE_PROMO_CODE_SUCCESS = 'CREATE_PROMO_CODE_SUCCESS';
export const CREATE_PROMO_CODE_FAILS = 'CREATE_PROMO_CODE_FAILS';

// list promo codes
export const FETCH_PROMO_CODES = 'FETCH_PROMO_CODES';
export const FETCH_PROMO_CODES_SUCCESS = 'FETCH_PROMO_CODES_SUCCESS';
export const FETCH_PROMO_CODES_FAILS = 'FETCH_PROMO_CODES_FAILS';